export default __webpack_public_path__ + "src/images/packages/summerfields-rose-retreat/8c23560899a80f62a6e56b145ee13853-4.jpg";